import React, { useEffect, useState } from "react";
import SgpaComponent from "./SgpaComponent";
import './Sgpa.css'
import {MdPlaylistAdd} from "react-icons/md"


function Sgpa() {
  const [subjects, setSubjects] = useState(["Subject Name"]);
  const [grades, setGrades] = useState(["null"]);
  const [points, setPoints] = useState([0]);
  const [credits, setCredits] = useState([0]);
  const [sgpa, setSgpa] = useState();

  function handleAdd() {
    setSubjects((prev) => [...prev, "Subject Name"]);
    setGrades((prev) => [...prev, "null"]);
    setPoints((prev) => [...prev, 0]);
    setCredits((prev) => [...prev, 0]);
  }
  useEffect(() => {
    handleAdd()
    handleAdd()
    handleAdd()
   } , []);



  
  



  useEffect(() => {
    // handlePoints();
    calcSgpa();
  });
 
  function calcSgpa() {
    let totalCredits = 0;
    let totalPoints = 0;
    
    for (let i = 0; i < credits.length; i++) {
      if ((credits[i] !=='none') || (points[i]!=='none') ){
        totalCredits = totalCredits + parseInt(credits[i]);
      }
      
    }
    
  
    for (let i = 0; i < points.length; i++) {
      if ((credits[i] !=='none') || (points[i]!=='none') ){
        totalPoints += (points[i] * credits[i]); 
        console.log(totalPoints);
      }
     
    }
   
   
    
    

    setSgpa((totalPoints / totalCredits).toFixed(2));
    totalPoints=0;
    totalCredits=0;
  }

  function handleGrade(event, i) {
    let newGrades = [...grades];
    newGrades[i] = event.target.value;
    handlePoints(newGrades[i],i);
    setGrades(newGrades);
   
   
  }

  function handleDelete(valueIndex){
    
    setPoints(points.filter((point, index) => valueIndex !== index)); 
    setCredits(credits.filter((credit, index) => valueIndex !== index));
    setGrades(grades.filter((grade, index) => valueIndex !== index));
    setSubjects(subjects.filter((subject, index) => valueIndex !== index));  
    

  }


  function handleCredits(event, i) {
    let newCredits = [...credits];
    newCredits[i] = event.target.value;
    setCredits(newCredits);
  
  }

  function handlePoints(grades,i){
    if (grades === "null") {
      const newPoints = [...points];
      newPoints[i] = 0;
      setPoints(newPoints);
    }
    if (grades === "O") {
      const newPoints = [...points];
      newPoints[i] = 10;
      setPoints(newPoints);
    }
    if (grades === "A+") {
      let newPoints = [...points];
      newPoints[i] =9;
      setPoints(newPoints);
    }
    if (grades === "A") {
      let newPoints = [...points];
      newPoints[i] = 8;
      setPoints(newPoints);
    }

    if (grades === "B+") {
      let newPoints = [...points];
      newPoints[i] = 7;
      setPoints(newPoints);
    }
    if (grades === "B") {
      let newPoints = [...points];
      newPoints[i] = 6;
      setPoints(newPoints);
    }
    if (grades === "C") {
      let newPoints = [...points];
      newPoints[i] = 5;
      setPoints(newPoints);
    }
    if (grades === "F") {
      let newPoints = [...points];
      newPoints[i] = 0;
      setPoints(newPoints);
    }
    if (grades === "ab") {
      let newPoints = [...points];
      newPoints[i] =0;
      setPoints(newPoints);
    }
    if (grades === "I") {
      let newPoints = [...points];
      newPoints[i] = 0;
      setPoints(newPoints);
    }
    console.log(points)
  }

  const [buttonText, setButtonText] = useState("Calculate");
  const [visible, setvisible] = useState(false);
  const [clicks, setClicks] = useState(0);

  const handleClick = () => {
    setClicks(clicks + 1);
    if (clicks === 0) {
      setButtonText("Reset");
      setvisible(true);
    } else {
      window.location.reload();
    }
  };
  return (
    <div className="sgpahead">
      <div className="calc">
      <button onClick={handleClick}>{buttonText}</button>
      {visible &&<div><div className='sgpa'>Your Grade Point Average is : <strong>{sgpa}</strong></div></div>}
    </div>

    <div className="titletag">
            <span>credits</span>
             <span>grades</span>
          </div>
      {subjects.map((subject, i) => {
        return (
          <>
          <SgpaComponent
            
            handleDelete={handleDelete}
            subject={subject}
            grade={grades[i]}
            credit={credits[i]}
            point={points[i]}
            index={i}
            handleGrade={handleGrade}
            handleCredits={handleCredits}
          />
          </>
        );
      })}
      <button className='addtab' onClick={handleAdd}> <MdPlaylistAdd  size={25}/> </button>
    </div>
  );

}

export default Sgpa;
